import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/item-stavax-account.png")